import Vue from 'vue'

export default {
  getAddressOfGeoCode: function ({lat, lng}) {
    let apiPath = 'https://maps.googleapis.com/maps/api/geocode/json'
    let apiKey = Vue.env.googleMapAPIKey
    apiPath += '?latlng=' + lat + ',' + lng
    apiPath += `&key=` + apiKey
    apiPath += `&channel=3`
    return Vue.http.get(apiPath)
  }
}



// WEBPACK FOOTER //
// ./src/apis/google.js